export default __webpack_public_path__ + "static/media/solteiroduplo_8.1e1fe020.jpg";